// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import constants from "@store/constants";
import { getBlogCategoryArticlesParameter } from "@store/Framework/Store/Starter/Pages/BlogCategory/BlogCategorySelector";

export const getBlogCategoryArticlesDataView = (state: ApplicationState, useCacheInvalidationId?: boolean) => {
    const currentPage = getCurrentPage(state);
    const blogCategoryArticlesParameters = getBlogCategoryArticlesParameter(state);

    return getDataView(state.data.pages, {
        ...blogCategoryArticlesParameters,
        nodeId: currentPage.nodeId,
        type: constants.blog.getDataViewType.categoryArticles,
        cacheInvalidationId: useCacheInvalidationId ? blogCategoryArticlesParameters.cacheInvalidationId : undefined,
    });
};

export const getBlogCategoryFeaturedArticleDataView = (state: ApplicationState, pageLink: string) => {
    return getDataView(state.data.pages, {
        pageLink,
        type: constants.blog.getDataViewType.featuredArticle,
    });
};
